import { SET_ITEM_SHOP } from './types.js'
import axios from 'axios'
export default {
  setItemShop({ commit }, payload) {
    commit(SET_ITEM_SHOP, payload)
  },
  async requestItemShop (state, parameter) {
    let endpoint = '/api/itemshop'
    if (parameter.isPublic) endpoint = '/api/public/itemshop'

    return axios.get(endpoint, { params: parameter.payload })
      .then(response => {
        state.dispatch('setItemShop', response.data.data)
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  async requestBuy (state, parameters) {
    return axios.post('/api/itemshop/buy', parameters)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  async requestAddItem (state, parameter) {
    return axios.post('/api/itemshop/add-item', parameter)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  async requestDelete (state, productNum) {
    return axios.delete(`/api/itemshop/${productNum}`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  async requestUpdate (state, parameter) {
    return axios.post(`/api/itemshop/update/${parameter.ProductNum}`, parameter)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  async buyNightMarketItem(context, parameter) {
    return axios.post(`api/user/night-market/buy`, parameter)
      .then(response=> {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
  async requestItemFetch (state, parameter) {
    return axios.get('/api/itemshop/fetch-items', { params: { ...parameter } })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  async requestUpdateItemList (state, parameter) {
    return axios.post('/api/itemshop/item-list-update', parameter)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  async requestBuyTopup (state, parameters) {
    let endpoint = '/api/user/create-sessions'

    if (parameters.UserID) {
      endpoint = '/api/public/create-sessions'
    }

    return axios.post(endpoint, parameters)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
}